var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinnedDocumnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8577 37.6709C28.7656 40.787 14.433 40.1253 0.0263672 39.3735V5.22852H39.7139C40.1207 19.6388 40.4888 31.9635 37.8577 37.6709Z",
    fill: "#59616E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8099 36.8751C27.7178 39.9912 14.433 40.1253 0.0263672 39.3735V5.22852H39.7139C40.1207 19.6388 39.441 31.1677 36.8099 36.8751Z",
    fill: "#C4CBD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84154 6.50432L6.05176 6.95508L7.87501 9.31965L8.66479 8.86889L6.84154 6.50432Z",
    fill: "#768090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92571 9.94558L7.875 9.32036L8.66481 8.86963L8.92571 9.94558Z",
    fill: "#707070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92478 4.36789C9.55639 5.18959 8.55712 6.36785 6.92224 7.29801C5.28736 8.22817 3.63598 8.55801 3.00436 7.7363C2.37275 6.91458 2.81415 5.01055 4.44902 4.08039C6.08391 3.15023 8.29318 3.54617 8.92478 4.36789Z",
    fill: "#59616E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57708 0.183039C4.87935 0.575092 4.11455 1.46924 2.86885 2.18015C1.62315 2.89107 0.36826 3.14955 0.065994 2.75749C-0.236288 2.36543 0.528506 1.47129 1.77422 0.760385C3.01991 0.0494652 4.2748 -0.209014 4.57708 0.183039Z",
    fill: "#59616E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46289 2.65928L3.92018 1.18628L7.24368 4.71961L4.16429 6.56553L1.46289 2.65928Z",
    fill: "#768090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedDocumnet);
export default __webpack_public_path__ + "static/media/PinnedDocumnet.da580020c6c234a300c391a29e080ffa.svg";
export { ForwardRef as ReactComponent };